<!-- Logo & Menu Toggle -->
<div box
  direction="row"
  fill="horizontal"
  align="center"
  justify="center"
  [wrap]="false"
  class="root-sidebar"
  [ngClass]="{ 'icon-view__container': layoutState.isIconView }">
  @if (layoutState.isMobileView) {
    <button mat-icon-button
      class="nav__toggle-btn-mobile"
      (click)="toggleMobileNavigation()"
      [disableRipple]="true">
      <mat-icon svgIcon="menu"></mat-icon>
    </button>
  }
  <div box
    direction="row"
    fill="horizontal"
    align="center"
    justify="center"
    [wrap]="false"
    class="app-logo__container">
    <img [routerLink]="['/home']" class="logo" alt="Newmark"
      src="{{ layoutState.isIconView ? iconLogo : fullLogo }}"/>
    @if (!layoutState.isIconView && !layoutState.isMobileView) {
      <button mat-icon-button
        class="nav__toggle-btn xs"
        (click)="toggleNavigation()"
        [disableRipple]="true">
        <mat-icon svgIcon="menu"></mat-icon>
      </button>
    }
  </div>
</div>

<mat-divider></mat-divider>

<!-- Standard Menu -->
@if (!layoutState.isIconView) {
  <mat-nav-list class="color-white" [ngClass]="{ 'mat-mdc-nav-list__open': layoutState.isMobileMenuOpen }"
    >
    @for (item of navItems; track item) {
      <a mat-list-item
        [routerLink]="!item.disabled ? ['/' + item.route] : null"
        class="nav-link"
        [ngClass]="{ disabled: item.disabled }"
        routerLinkActive="active"
        >
        <mat-icon matListItemIcon svgIcon="{{ item.icon }}"></mat-icon>
        @if (!layoutState.isIconView) {
          <div>
            <span class="matomo_leftnav"> {{ item.name | transloco }}</span>
          </div>
        }
      </a>
    }
    <mat-divider class="nav__divider"></mat-divider>
    <nav-section [sectionName]="'sharedNav.appSidebar.reportsAnalytics' | transloco"
      svgIcon="reports">
      @if (enableQuotesReport) {
        <a mat-list-item
          class="matomo_leftnav nested-item"
          (click)="openQuotesIntelligence()">
          @if (!layoutState.isIconView) {
            <div>
              <span class="matomo_leftnav"> {{ 'sharedNav.appSidebar.quotesIntelligence' | transloco }}</span>
            </div>
          }
        </a>
      }
      @if (user.isAdmin) {
        <a mat-list-item
          href="https://Greedo.ideal.io/ReportV3"
        class="matomo_leftnav nested-item"
        target="_blank">
        {{ 'sharedNav.appSidebar.managementReports' | transloco }}
      </a>
      }
      <a href="https://Greedo.ideal.io/ReportV3/Broker"
        target="_blank" mat-list-item class="matomo_leftnav nested-item"
        (click)="onBrokerReportsClick()">
        {{ 'sharedNav.appSidebar.brokerReports' | transloco }}
      </a>
      <a href="https://ssrs.ideal.io/Reports/browse/"
        target="_blank" mat-list-item class="matomo_leftnav nested-item">
        {{ 'sharedNav.appSidebar.legacyReports' | transloco }}
      </a>
      <a href="/query-tool"
        target="_blank"
        routerLink="/query-tool"
        mat-list-item class="matomo_leftnav nested-item"
        >
        {{ 'sharedNav.appSidebar.queryTool' | transloco }}
      </a>
    </nav-section>
    <nav-section [sectionName]="'sharedNav.appSidebar.support' | transloco"
      svgIcon="help-icon">
      <mat-list-item class="nested-item"
        (click)="showFreshWidget()">
        <div
          class="matomo_leftnav">{{ 'sharedNav.appSidebar.help' | transloco }}
        </div>
      </mat-list-item>
      <a href="{{releaseNoteUrl}}"
        target="_blank">
        <mat-list-item class="nested-item">
          <div
            class="matomo_leftnav">{{ 'sharedNav.appSidebar.releaseNotes' | transloco }}
          </div>
        </mat-list-item>
      </a>
      @if (enableResources) {
        <a href="https://ngkfcs.sharepoint.com/teams/IdealEngagement"
          target="_blank">
          <mat-list-item class="nested-item">
            <div
              class="matomo_leftnav">{{ 'sharedNav.appSidebar.resources' | transloco }}
            </div>
          </mat-list-item>
        </a>
      }
    </nav-section>
  </mat-nav-list>
}

<!-- Icon Menu -->
@if (layoutState.isIconView) {
  <nav class="icon-view__list">
    @for (item of navItems; track item) {
      <a class="icon-view__btn"
        [routerLink]="!item.disabled ? ['/' + item.route] : null"
        [routerLinkActive]="item.disabled ? 'disabled' : 'active'"
        [class.disabled]="item.disabled"
        [title]="item.name | transloco">
        <mat-icon [svgIcon]="item.icon"></mat-icon>
      </a>
    }
    <button type="button"
      class="icon-view__btn"
      [matMenuTriggerFor]="reportsMenu"
      [title]="'sharedNav.appSidebar.reportsAnalytics' | transloco">
      <mat-icon svgIcon="reports"></mat-icon>
    </button>
    <mat-menu #reportsMenu>
      @if (enableQuotesReport) {
        <a mat-list-item
          [routerLink]="'/quotes-intelliegence-dashboard'"
          class="nav-link"
          [routerLinkActive]="'active'">
          @if (!layoutState.isIconView) {
            <div>
              <span class="matomo_leftnav">{{ 'sharedNav.appSidebar.quotesIntelligence' | transloco }}</span>
            </div>
          }
        </a>
      }
      @if (user.isAdmin) {
        <a
          href="/Report"
          target="_blank">
          <button mat-menu-item
            class="matomo_leftnav">{{ 'sharedNav.appSidebar.managementReports' | transloco }}
          </button>
        </a>
      }
      <a href="/Report/Broker"
        target="_blank"
        (click)="onBrokerReportsClick()">
        <button mat-menu-item
          class="matomo_leftnav">{{ 'sharedNav.appSidebar.brokerReports' | transloco }}
        </button>
      </a>
      <a href="https://ssrs.ideal.io/Reports/browse/"
        target="_blank">
        <button mat-menu-item
          class="matomo_leftnav">{{ 'sharedNav.appSidebar.legacyReports' | transloco }}
        </button>
      </a>
      <a href="/query-tool"
        routerLink="/query-tool"
        target="_blank">
        <button mat-menu-item
          class="matomo_leftnav">{{ 'sharedNav.appSidebar.queryTool' | transloco }}
        </button>
      </a>
    </mat-menu>
    <mat-divider class="nav__divider"></mat-divider>
    <button type="button"
      class="icon-view__btn"
      [matMenuTriggerFor]="supportMenu"
      [title]="'sharedNav.appSidebar.support' | transloco">
      <mat-icon svgIcon="help-icon"></mat-icon>
    </button>
    <mat-menu #supportMenu>
      <button mat-menu-item
        (click)="showFreshWidget()">
        {{ 'sharedNav.appSidebar.help' | transloco }}
      </button>
      <a href="{{releaseNoteUrl}}"
        target="_blank">
        <button mat-menu-item
          class="matomo_leftnav">
          {{ 'sharedNav.appSidebar.releaseNotes' | transloco }}
        </button>
      </a>
      @if (enableResources) {
        <a href="https://ngkfcs.sharepoint.com/teams/IdealEngagement"
          target="_blank">
          <button mat-menu-item
            class="matomo_leftnav">
            {{ 'sharedNav.appSidebar.resources' | transloco }}
          </button>
        </a>
      }
    </mat-menu>
  </nav>
}
